import { memo } from 'react';
import styled from 'styled-components';
import { Tooltip } from 'antd';
import moment from 'moment';
import { TimelineItemProps } from '@modules/timetable';
import { locationQuery, locationQueryVariables, LOCATIONS, order_by } from '@app-types/graphql-types';
import { useQuery } from '@apollo/client';
import { useMst } from '@models/Root';
import { TimelineItemTypeType } from '@app-types/timetable';

const TimelineInner = styled.div`
  width: 100%;
  text-align: center;
  height: 100%;

  .rct-item-handler-resize-right,
  .rct-item-handler-resize-left {
    cursor: col-resize !important;
    background-color: #ffc107 !important;
    width: 4px !important;
  }

  .timeline-item-section {
    height: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .timeline-item-text {
    transform: rotate(270deg);
    display: inline-block;
    font-size: 9px;
  }
`;

export const TimelineItem = memo(
  ({ item, itemContext, getItemProps, getResizeProps }: TimelineItemProps) => {
  const { left: leftResizeProps, right: rightResizeProps } = getResizeProps();
  const {
    className,
    key,
    onContextMenu,
    onDoubleClick,
    onMouseDown,
    onMouseUp,
    onTouchEnd,
    onTouchStart,
    ref,
    style,
    title,
    onClick,
  } = getItemProps(undefined);
  const { setSelectedTimelineItem, setSelectedDraggableItem } = useMst().timetable;

  const { data: locationData } = useQuery<locationQuery, locationQueryVariables>(LOCATIONS, {
    variables: {
      order_by: [
        {
          name: order_by.asc,
        },
      ],
    },
  });

  const selectedLocation = locationData?.location.find(
    (individualLocation) => individualLocation.id === item.locationID,
  );

  let locationSectionStyle;

  if (selectedLocation) {
    locationSectionStyle = {
      backgroundColor: selectedLocation.color,
      backgroundImage: 'none',
    };
  } else {
    locationSectionStyle = {
      backgroundImage: `linear-gradient(
      150deg,
      ${item.color} 25%,
      #dddddd 25%,
      #dddddd 50%,
      ${item.color} 50%,
      ${item.color} 75%,
      #dddddd 75%,
      #dddddd 100%
    )`,
      backgroundSize: '20.00px 11.55px',
    };
  }
  return (
    <Tooltip
      mouseLeaveDelay={0.5}
      title={`${item.subjectName} - ${moment(item.startTime).format('LT')}-${moment(item.endTime).format('LT')}`}
    >
      <div
        role="menuitem"
        tabIndex={0}
        className={className}
        key={key}
        onContextMenu={onContextMenu}
        onDoubleClick={onDoubleClick}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onTouchEnd={onTouchEnd}
        onTouchStart={onTouchStart}
        ref={ref}
        title={title}
        onClick={(event) => {
          setSelectedDraggableItem();
          setSelectedTimelineItem(item.id);
          onClick(event);
        }}
        style={{
          ...style,
          background: item.color,
          overflow: 'hidden',
          borderRadius: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <TimelineInner>
          {itemContext.useResizeHandle ? (
            <div
              ref={leftResizeProps?.ref}
              className={itemContext.selected ? leftResizeProps?.className : ''}
              style={leftResizeProps?.style}
            />
          ) : (
            ''
          )}

          <div
            className="timeline-item-section"
            style={{
              height: item.itemType !== TimelineItemTypeType.interval ? '50%' : '100%',
            }}
          >
            {itemContext.dimensions.width > 9.5 && (
              <span className="timeline-item-text">{itemContext.title.substring(0, 3).toUpperCase()}</span>
            )}
          </div>

          {itemContext.useResizeHandle ? (
            <div
              ref={rightResizeProps?.ref}
              className={itemContext.selected ? rightResizeProps?.className : ''}
              style={rightResizeProps?.style}
            />
          ) : (
            ''
          )}

          {item.itemType !== TimelineItemTypeType.interval && (
            <div className="timeline-item-section timeline-item-location-section" style={locationSectionStyle}>
              {itemContext.dimensions.width > 9.5 && (
                <span className="timeline-item-text">{selectedLocation?.name.substring(0, 3).toUpperCase()}</span>
              )}
            </div>
          )}
        </TimelineInner>
      </div>
    </Tooltip>
  );
});
